export enum LoadingSpinnerClassName {
  Base = "loading-spinner",
}
